/** Modulo Cargo (60) — codigos em contracts/enums.yaml */
export const CARGO_ACAO = {
  CRIAR: 601,
  ATUALIZAR: 602,
  REMOVER: 603,
} as const;

export const CARGO_ACOES_MODULO = [CARGO_ACAO.CRIAR, CARGO_ACAO.ATUALIZAR, CARGO_ACAO.REMOVER] as const;
